module.exports = __webpack_public_path__ + "static/media/virus (9).0bfa3155.png";